export default __webpack_public_path__ + "static/media/institute.f82bce25.svg";